// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3DHF9","emails":"CreateEditClinics_emails__2EmvY","emailTagLabel":"CreateEditClinics_emailTagLabel__2l4rD"};